var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33474 5.76247C2.78105 5.31616 3.50467 5.31616 3.95098 5.76247L10 11.8115L16.049 5.76247C16.4953 5.31616 17.219 5.31616 17.6653 5.76247C18.1116 6.20878 18.1116 6.9324 17.6653 7.37871L10.8081 14.2359C10.3618 14.6822 9.63819 14.6822 9.19188 14.2359L2.33474 7.37871C1.88842 6.9324 1.88842 6.20878 2.33474 5.76247Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCaret);
export default __webpack_public_path__ + "static/media/downCaret.20df5f64fc08a497c8a59a420a17d826.svg";
export { ForwardRef as ReactComponent };